import { t } from "i18next";

import { Box, SxProps } from "@mui/material";

interface UserInfoProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  companyName?: string;
  roleName?: string;
  sx?: SxProps;
}

const UserInfo = ({
  firstName,
  lastName,
  email,
  companyName,
  roleName,
  sx
}: UserInfoProps) => {
  const name = [firstName, lastName].filter((n) => n).join(" ");

  return (
    <Box
      sx={{
        maxWidth: ["11rem", "22rem"],
        overflow: "hidden",
        textAlign: "left",
        mr: [1.5, 3],
        ...sx
      }}
    >
      <Box
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          lineHeight: "1.25"
        }}
      >
        {name ? name : t("general.unnamedUser")}
      </Box>
      {email ? (
        <Box
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: (theme) => theme.typography.tooltip.fontSize
          }}
        >
          {email}
        </Box>
      ) : undefined}
      {companyName && (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: (theme) => theme.typography.tooltip.fontSize
          }}
        >
          {companyName}
        </Box>
      )}
      {!companyName && roleName && (
        <Box
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: (theme) => theme.typography.tooltip.fontSize
          }}
        >
          {roleName}
        </Box>
      )}
    </Box>
  );
};

export default UserInfo;
